import { Component }            from '@angular/core';
import { NavController }        from 'ionic-angular';
import { AlertController }      from 'ionic-angular';
import { LoadingController }    from 'ionic-angular';
import { ModalController }      from 'ionic-angular';
import { Platform }             from 'ionic-angular';
import { dmHotel }              from '../sign-in/xv-hotel';
import { RatesViewModel }       from './xv-rates';
import { MLText, mlBroker }     from '../../services/MLText';
import { AppDataBroker }        from '../../services/AppData';
import { SignInPage }           from '../sign-in/sign-in';
import { dmLoading }            from '../loading/loading';

import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";

@Component({
   selector:    'page-rates'
  ,templateUrl: 'rates.html'
})
export class RatesPage {
    Rates:              RatesViewModel;
    ShowAlert:          (pTitle: string, pMessage: string) => void;
    NewLoading:         (pMessage: string)                 => dmLoading;
    BackToSignIn:       ()                                 => void;
    DetectWidth:        ()                                 => number;
    RegisterResize:     (pAction: () => void)              => void;
    ShowCalendar:       (
         pToday:        Date
        ,pCDay:         Date
        ,pTitle:        string
        ,pLangID:       number
        ,pAction:       (pCDay: Date) => void
    ) => void;
    ShowPeriodCalendar: (
         pToday:        Date
        ,pStart:        Date
        ,pEnd:          Date
        ,pTitle:        string
        ,pLangID:       number
        ,pAction:       (pFrom: Date, pTo: Date) => void
    ) => void;

    app:                mlBroker;
    ResizeHandler:      any;

    constructor(
         public platform:      Platform
        ,public navCtrl:       NavController
        ,public alertCtrl:     AlertController
        ,public loadingCtrl:   LoadingController
        ,public modalCtrl:     ModalController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel          = appDataBroker.GetAppData() as dmHotel;

        this.app           = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );

        this.ResizeHandler = null;

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.DetectWidth = () => {
            return platform.width();
        };

        this.RegisterResize = (pAction: () => void) => {
            this.ResizeHandler = platform.resize.subscribe(() => {
                pAction();
            });
        };

        this.ShowCalendar = (
             pToday:  Date
            ,pCDay:   Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pCDay: Date) => void
        ) => {
            const options: CalendarModalOptions = {
                 pickMode:        'single'
                ,title:            pTitle
                ,from:             pToday
                ,defaultDate:      pCDay
                ,defaultScrollTo:  pCDay
                ,color:            'danger'
            };

            let calendar = this.modalCtrl.create(CalendarModal ,{
                options: options
            });

            calendar.onDidDismiss((
                 date: CalendarResult
                ,type: string
            ) => {
                if (
                    (type == 'cancel')
                ||  (type == 'backdrop')
                ||  (!date.dateObj)
                ) { return; }

                pAction(date.dateObj);
            });

            calendar.present();
        };

        this.ShowPeriodCalendar = (
             pToday:  Date
            ,pStart:  Date
            ,pEnd:    Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pFrom: Date, pTo: Date) => void
        ) => {
            if (pStart <  pToday) { pStart = pToday; }
            if (pEnd  <= pStart)   {
                pEnd   = new Date(pStart);

                pEnd.setDate(pEnd.getDate() + 1);
            }

            const options: CalendarModalOptions = {
                 pickMode:        'range'
                ,title:            pTitle
                ,from:             pToday
                ,defaultDateRange: { from: pStart, to: pEnd }
                ,color:            'danger'
            };

            let calendar = this.modalCtrl.create(CalendarModal ,{
                options: options
            });

            calendar.onDidDismiss((
                 date: { from: CalendarResult; to: CalendarResult }
                ,type: string
            ) => {
                if (
                    (type == 'cancel')
                ||  (type == 'backdrop')
                ||  (!(date.from.dateObj && date.to.dateObj))
                ) { return; }

                pAction(date.from.dateObj, date.to.dateObj);
            });

            calendar.present();
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Rates = new RatesViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.ShowAlert
            ,this.NewLoading
            ,this.DetectWidth
            ,this.RegisterResize
            ,this.ShowCalendar
            ,this.ShowPeriodCalendar
        );
    }

    ionViewWillUnload() {
        if (this.ResizeHandler) { this.ResizeHandler.unsubscribe(); }
    }
}



// WEBPACK FOOTER //
// ./src/pages/rates/rates.ts